export enum ApiErrorTypeSM {
    Fatal_Log = 1,
    Success_NoLog = 2,
    InvalidToken_Log = 3,
    FrameworkException_Log = 4,
    InvalidInputData_Log = 5,
    InvalidInputData_NoLog = 6,
    NoRecord_Log = 7,
    NoRecord_NoLog = 8,
    ModelError_Log = 9,
    ModelError_NoLog = 10,
    Access_Denied_Log = 11,
    Access_Denied_NoLog = 12
}
